import { useLocaleObject } from '@layers/i18n/app/composables/useLocaleObject'

export function usePrizeMoney() {
  const config = useRuntimeConfig()
  const localeObject = useLocaleObject()
  const priceFormatter = usePriceFormatter()
  const prizeMoney = config.public.prizeMoney[localeObject.value.currency]
  return computed(() => priceFormatter(+prizeMoney * 100, localeObject.value.currency))
}
